/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('site.filter', function (el) {
        var resultsContainer = el.dataset.filterContainer ? document.querySelector(el.dataset.filterContainer) : el.querySelector('.filter-container');
        var toggles = Array.from(el.querySelectorAll('[data-filter-class]')).map(function (el) {
            return FilterToggle.create(el);
        });
        if (!toggles) {
            console.debug('Missing filter toggles');
        }
        if (!resultsContainer) {
            console.debug('Missing filter container');
        }
        var results = Array.from(resultsContainer.children).map(function (result) {
            return FilterResult.create(result);
        });
        if (!results) {
            console.debug('Missing filter results');
        }
        var config = {
            el: el,
            resultsContainer: resultsContainer,
            results: results,
            toggles: toggles,
            transitionName: el.dataset.transition,
            searchElement: el.dataset.searchElement,
        };
        Filter.create(config).run();
    });
    var Filter = /** @class */ (function () {
        function Filter(config) {
            this.el = config.el;
            this.resultsContainer = config.resultsContainer;
            this.results = config.results;
            this.toggles = config.toggles;
            this.transitionName = config.transitionName;
            this.searchElement = config.searchElement;
        }
        Filter.create = function (config) {
            return new Filter(config);
        };
        Filter.prototype.run = function () {
            this.addInitialClasses();
            this.delegateEvents();
            /*if (this.toggleFromQueryParam()) {
                return;
            }*/
            this.removeInitClass();
        };
        Filter.prototype.removeInitClass = function () {
            this.resultsContainer.classList.remove('isFiltering');
        };
        Filter.prototype.addInitialClasses = function () {
            this.resultsContainer.classList.add('filter-container');
            if (this.transitionName) {
                this.resultsContainer.classList.add(this.transitionName);
            }
        };
        Filter.prototype.delegateEvents = function () {
            var _this = this;
            util.delegate(this.el, 'change', 'select', function (e) {
                var selectElm = e.delegateTarget;
                var selectedIndex = selectElm.selectedIndex;
                e.preventDefault();
                if (selectedIndex === 0) {
                    for (var i = 1; i < selectElm.options.length; i++) {
                        var filterToogleClass = selectElm.options[i].dataset.filterClass;
                        var filterToggle_1 = _this.getToggleByFilterClass(filterToogleClass);
                        if (filterToggle_1) {
                            filterToggle_1.unmarkActive();
                        }
                    }
                    var hasActiveToggle_1 = false;
                    _this.toggles.forEach(function (t) {
                        if (t.isActive()) {
                            hasActiveToggle_1 = true;
                        }
                    });
                    if (!hasActiveToggle_1) {
                        _this.toggles.forEach(function (t) {
                            t.unmarkActive();
                        });
                        _this.results.forEach(function (r) {
                            r.show();
                        });
                    }
                    return;
                }
                console.log('asdf');
                var filterToggle = _this.getToggleByFilterClass(selectElm.options[selectedIndex].dataset.filterClass);
                if (!filterToggle) {
                    return;
                }
                _this.clickToggle(filterToggle);
            });
            if (this.searchElement) {
                util.delegate(this.el, 'keyup', this.searchElement, function (e) {
                    var el = e.target;
                    if (el instanceof HTMLInputElement) {
                        _this.searchValue = el.value;
                        _this.filterResults();
                    }
                });
            }
        };
        Filter.prototype.clickToggle = function (toggle) {
            if (toggle.isActive()) {
                toggle.unmarkActive();
            }
            else {
                this.toggles.forEach(function (t) {
                    if (t !== toggle && t.getElement().parentNode == toggle.getElement().parentNode) {
                        t.unmarkActive();
                    }
                });
                toggle.markActive();
            }
            this.filterResults();
            //this.updateQuery();
        };
        Filter.prototype.getActiveFilterClasses = function (separator) {
            return this.toggles.filter(function (toggle) {
                return toggle.isActive();
            }).map(function (toggle) {
                return toggle.getFilterClassNames();
            }).join(separator);
        };
        Filter.prototype.filterResults = function () {
            var _this = this;
            var classes = this.getActiveFilterClasses('.');
            var yearData = this.getActiveFilterYearData();
            var searchValue = this.searchValue;
            this.resultsContainer.classList.add('isFiltering');
            var counter = 0;
            setTimeout(function () {
                _this.results.forEach(function (result) {
                    var matches = '';
                    if (classes) {
                        matches = classes;
                    }
                    if (yearData) {
                        matches = matches + '[data-year="' + yearData + '"]';
                    }
                    if (classes && matches.charAt(0) !== '.') {
                        matches = '.' + matches;
                    }
                    var show = (!classes && !yearData) || result.getElement().matches(matches);
                    console.log(show);
                    if (searchValue) {
                        show = result.getElement().innerText.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
                    }
                    if (show) {
                        result.show();
                        counter++;
                    }
                    else {
                        result.hide();
                    }
                });
                _this.resultsContainer.classList.remove('isFiltering');
                if (counter) {
                    _this.resultsContainer.classList.remove('noResults');
                }
                else {
                    _this.resultsContainer.classList.add('noResults');
                }
            }, 200);
        };
        Filter.prototype.getToggleByFilterClass = function (filterClass) {
            return this.toggles.filter(function (toggle) {
                return toggle.getFilterClass() === filterClass;
            }).shift();
        };
        /*
            private toggleFromQueryParam(): boolean
            {
                const hash = window.location.hash.slice(1).replace('%7C', '|');
                if (!hash) {
                    return false;
                }

                hash.split('|').forEach((filterClass) => {
                    let t = this.getToggleByFilterClass(filterClass);
                    t.markActive();
                });
                this.filterResults();
                return true;
            }

            private updateQuery() {
                const classes = this.getActiveFilterClasses('|');

                if (!classes) {
                    window.history.replaceState('', '', window.location.pathname);
                    return;
                }
                const filterQueryParam = '#' + classes;
                window.history.replaceState('', '', filterQueryParam);
            }
        */
        Filter.prototype.getActiveFilterYearData = function () {
            return this.toggles.filter(function (toggle) {
                return toggle.isActive();
            }).map(function (toggle) {
                return toggle.getYearData();
            }).join('');
        };
        return Filter;
    }());
    var FilterToggle = /** @class */ (function () {
        function FilterToggle(el) {
            this.el = el;
            this.filterClass = el.dataset.filterClass;
        }
        FilterToggle.create = function (el) {
            return new FilterToggle(el);
        };
        FilterToggle.prototype.getElement = function () {
            return this.el;
        };
        FilterToggle.prototype.getFilterClass = function () {
            return this.filterClass;
        };
        FilterToggle.prototype.getFilterClassNames = function () {
            if (!isNaN(Number(this.filterClass))) {
                return '';
            }
            return this.filterClass;
        };
        FilterToggle.prototype.isActive = function () {
            return this.active;
        };
        FilterToggle.prototype.markActive = function () {
            this.el.classList.add('active');
            this.active = true;
        };
        FilterToggle.prototype.unmarkActive = function () {
            this.el.classList.remove('active');
            this.active = false;
        };
        FilterToggle.prototype.getYearData = function () {
            var filterClass = (this.el.dataset.filterClass);
            if (!isNaN(Number(filterClass))) {
                return filterClass;
            }
            return undefined;
        };
        return FilterToggle;
    }());
    var FilterResult = /** @class */ (function () {
        function FilterResult(el) {
            this.el = el;
        }
        FilterResult.create = function (el) {
            return new FilterResult(el);
        };
        FilterResult.prototype.getElement = function () {
            return this.el;
        };
        FilterResult.prototype.show = function () {
            this.el.style.removeProperty('display');
        };
        FilterResult.prototype.hide = function () {
            this.el.style.display = 'none';
        };
        return FilterResult;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
